import {
  webDocumentResearchToolMaxAllowedDomainCount,
  webDocumentResearchToolSettingsSchema,
  type WebDocumentResearchToolSettings,
} from "@repo/app-types/entities/tools/webDocumentResearch";
import {
  WebDocumentResearchToolForm,
  type WebDocumentResearchToolFormSettings,
} from "../components/webDocumentResearchToolForm.js";
import type { ToolFormConfig } from "./baseFormConfig.js";
import { buildInvalidAllowedDomainError } from "./webDocumentResearchAllowedDomains.js";

export const webDocumentResearchToolFormConfig: ToolFormConfig<
  WebDocumentResearchToolSettings,
  WebDocumentResearchToolFormSettings
> = {
  initialize: (settings) => ({
    allowedDomains: settings?.allowed_domains ?? [],
    allowedDomainsError: undefined,
  }),
  validate: (settings) =>
    settings.allowedDomains.length > 0 &&
    settings.allowedDomains.length <=
      webDocumentResearchToolMaxAllowedDomainCount,
  save: (settings) => {
    const result = webDocumentResearchToolSettingsSchema.safeParse({
      allowed_domains: settings.allowedDomains,
    });
    if (!result.success) {
      const issue = result.error.issues[0];
      // ["allowed_domains"] for an array-level issue, plus the index for an item.
      const index = issue?.path[1];
      const domain =
        typeof index === "number" ? settings.allowedDomains[index] : undefined;

      return {
        isValid: false,
        formSettings: {
          allowedDomainsError:
            domain === undefined
              ? issue?.message
              : buildInvalidAllowedDomainError(domain, issue?.message ?? ""),
        },
      };
    }

    return { isValid: true, settings: result.data };
  },
  Form: WebDocumentResearchToolForm,
};
